import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const ArticleCard = ({ article }) => {
    const { language, t } = useLanguage();

    return (
        <div className="col-12 mxd-grid-item no-margin">
            <article className="mxd-post post-simple">
                <div className="post-simple__content">
                    <div className="post-simple__descr">
                        <div className="post-simple__meta">
                            <span className="meta-date">
                                {new Date(article.publishDate).toLocaleDateString(language, {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                            </span>
                        </div>
                        <div className="post-simple__title">
                            <h5>
                                <Link to={`/${language}/blog/${article.slug}`}>
                                    {article.title[language]}
                                </Link>
                            </h5>
                        </div>
                    </div>
                    <div className="post-simple__btn">
                        <Link className="btn btn-anim btn-default btn-outline slide-right-up" to={`/${language}/blog/${article.slug}`}>
                            <span className="btn-caption">{t('blog.read_more') || 'Leer más'}</span>
                            <i className="ph ph-arrow-up-right"></i>
                        </Link>
                    </div>
                </div>
            </article>
        </div>
    );
};

export default ArticleCard;